import React from 'react';
import { Content } from '@radix-ui/react-collapsible';
import type { ReactNode } from 'react';
import { Stack } from '@balance-web/stack';

export const CollapsableContent = ({ children }: { children: ReactNode }) => {
  return (
    <Content>
      <Stack paddingBottom="large" paddingX="xlarge">
        {children}
      </Stack>
    </Content>
  );
};
